import { useAuth0 } from '@auth0/auth0-react';
import { FormControlLabel, Switch, TextField } from '@material-ui/core';
import moment from 'moment';
import React, {useEffect, useRef, useState} from 'react';
import qs from 'qs';
import { RouteComponentProps } from 'react-router-dom';
import { FileUploader } from "file-uploader-react-component";
import {getStickerList, postSticker, putSticker, getStickerCategoryList } from '../utils/api';
import { accessToken, setAccessToken } from '../utils/auth';
import { MainList } from './MainList';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const columnInfo = [
    {
        label: '노출순서',
        name: 'sort',
        isAscending: true,
        isTextEditable: true,
        style: { minWidth: 110 },
    },
    {
        label: 'ID',
        name: '_id',
        style: { maxWidth: 220 },
        isAscending: false,
    },
    {
        label: '스티커명',
        name: 'name',
        isAscending: false,
        isTextEditable: true,
        style: { minWidth: 200 },
    },
    {
        label: '내용(획득전)',
        name: 'message1',
        style: { minWidth: 250 },
        isTextEditable: true,
    },
    {
        label: '내용(획득후)',
        name: 'message2',
        style: { minWidth: 250 },
        isTextEditable: true,
    },
    {
        label: '',
        name: 'imageUrl-preview',
        isAscending: false,
        isTextEditable: false,
        style: { minWidth: 70 },
    },
    {
        label: '스티커 이미지',
        name: 'imageUrl',
        style: { minWidth: 150, maxWidth: 250 },
        isTextEditable: true,
    },
    {
        label: '버튼 텍스트',
        name: 'buttonText',
        style: { minWidth: 150 },
        isTextEditable: true,
    },
    {
        label: '카테고리',
        name: 'categoryId',
        style: { minWidth: 100 },
        isSingleSelectable: true,

    },
    {
        label: '노출',
        name: 'visible',
        isAscending: false,
    },
    {
        label: '그룹',
        name: 'group',
        isTextEditable: true,
    },
    {
        label: '그룹 레벨',
        name: 'groupLevel',
        isTextEditable: true,
    },
    {
        label: '이벤트 페이지',
        name: 'eventPath',
        isTextEditable: true,
    },
    {
        label: '이동버튼 텍스트',
        name: 'moveButtonText',
        style: { minWidth: 150 },
        isTextEditable: true,
    },
    {
        label: '이동 경로',
        name: 'movePath',
        isTextEditable: true,
    },
    {
        label: '달성(시작)',
        name: 'challengeRange.rangeStart',
        isTextEditable: true,
    },
    {
        label: '달성(완료)',
        name: 'challengeRange.rangeEnd',
        isTextEditable: true,
    },

    {
        label: '최초 등록 일시',
        name: 'createdAt',
        isAscending: false,
        style: { minWidth: 120 },
    },
    {
        label: '최근 수정 일시',
        name: 'updatedAt',
        isAscending: false,
        style: { minWidth: 120 },
    },


];

let stickerList: any = [];
let stickerCategoryList: any = [];
let metadataList: any = [];
export const StickerList = () => {
    const [items, setItems] = useState<any>([]);
    const { getAccessTokenSilently } = useAuth0();

    // const [locale, setLocale] = React.useState<Locale | null>(null)
    const [name, setName] = React.useState('banners');
    const [url, setUrl] = React.useState('https://mqnddbigxf.execute-api.ap-northeast-2.amazonaws.com/v1/upload');
    const [method, setMethod] = React.useState('POST');

    const [newStickerId, setNewStickerId] = useState('');

    // const [page, setPage] = React.useState('1');
    // const [limit, setLimit] = React.useState('100');

    let page = '1';
    let limit = '1000';
    let search = '';

    const inputRef = useRef<HTMLInputElement>(null);
    const divRef = useRef<HTMLDivElement>(null);

    // const inputEl = useRef();
    //

    let selectedId = '';
    let selectedType = '';

    const imageUpload = (id: string): void => {
        if (!divRef.current) {
            return;
        }

        selectedId = id;
        // selectedType = type;
        selectedType = 'imageUrl';

        const element = document.getElementsByClassName('file-uploader-container')[0].children[1];
        if (element instanceof HTMLElement) {
            element.click();
        }
    }

    const fileUploaded = (response: any) => {
        const jsonObj = JSON.parse(response);

        handleInputSubmit(selectedId, selectedType, jsonObj.original);

        // const element = document.getElementsByClassName(`thumbnail-${selectedId}`)[0];
        // if(element instanceof HTMLImageElement){
        //     console.log('String');
        //     setTimeout(()=> {
        //
        //         const textarea = document.getElementById(selectedId);
        //         if(textarea instanceof HTMLTextAreaElement){
        //             textarea.value = jsonObj.large;
        //         }
        //
        //         element.src = jsonObj.large;
        //         element.width = 100;
        //
        //     }, 4000);
        // }

    }
    const fileGot = (file: File | Blob) => {

    }

    const beforeRequest= (request: XMLHttpRequest, formData: FormData) => {
        console.log('access token : ', accessToken);
        request.setRequestHeader('Authorization', `Bearer ${accessToken}` );
        // request.setRequestHeader('Authorization', 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjBwdmRfVkxqSW9kb21XaWlXOWZmYiJ9.eyJodHRwczovL2FkbWluLmhleWJ1bm55LmlvL3JvbGVzIjpbImFkbWluIl0sImlzcyI6Imh0dHBzOi8vYWNjb3VudHMuaGV5YnVubnkuaW8vIiwic3ViIjoiYXV0aDB8NjA3NGU0MTdiMDBmYTYwMDY5OGE3ZjA1IiwiYXVkIjpbImh0dHBzOi8vYXBpMy5oZXlidW5ueS5pbyIsImh0dHBzOi8vdHdpZ2Zhcm0uZXUuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTYyODc1MDUxNywiZXhwIjoxNjI4ODM2OTE3LCJhenAiOiJIQ1JGakd6QVlUZ0JjSlpFRThKYzRqZ29RUHlHd2tCaCIsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwifQ.BBLkOgQ1aoIPTSiALj-6D5qHwzK3TdKnJfhhejTOP-rGPT7FChMS4TFvwWS3-P961dAckAcIoGwNraq2ncyV8vg_QHJ7jsPb9zyTVCot3DErLhWsJe1kRHwNtzI-ICNPqkp4n_pH7RTwpVlX6ah-_gPXKhMQdDuE9vK3ZOrstNM0eLcMkcMc9Mi8ANkQSSpAsSmCg8iJWQMjeEEBE2VwDAJUOHc8u5gcCHolldmkJbAY7mf_sRBwknU3gGjRrrG-z_zG-JobBJwAgJjUmUp63WBSm_9waQHp7Pu4L7jC47Lx1gLltdyQ8L3QWSKfBC8bPnU0QmQ8i0dzOfMUSl6bJg');
        formData.append("type", 'banner');
        // return Promise.resolve(formData);
    }

    const constructList = async (isReload: boolean = false) => {
        if (isReload || stickerList.length === 0) {
            setAccessToken(await getAccessTokenSilently());
            const result = await getStickerList({params: {page: page, limit: limit, search: search}});

            const resultCount = result.length;
            // console.log("newsletterCount", newsletterCount);

            stickerList = result.stickerList.map((curation: any, index: number) => {
                return { ...curation, ...(curation.homeUsed === undefined ? {homeUsed: false}:{}), orderNo: resultCount - index };
            });
            metadataList = result.metadataList;

        }

        const categoryObject = await getStickerCategoryList({params: {'list': 1}});
        const categoryList = categoryObject?.categoryList || [];
        stickerCategoryList = categoryList.map((category: any) => {
            return { name: category.name, value : category._id };
        });
        // categoryList = result.categoryList.filter((elem: any) => !elem.hasOwnProperty('isPromotion') || elem.isPromotion !== true );

        setItems(
            stickerList.map((item: any, index: number) => {
                return {
                    ...item,
                    createdAt: moment(item.createdAt).format('YYYY.MM.DD HH:mm:ss'),
                    updatedAt: moment(item.updatedAt).format('YYYY.MM.DD HH:mm:ss'),
                    metaGroupNames:
                        item.metaGroupIds?.map((metaId: any) => {
                            const index = metadataList.findIndex((meta: any) => meta._id === metaId);
                            // if (index === -1) {
                            console.log('index: ', index, 'index: ', metadataList[index]?.title);
                            // }
                            return metadataList[index]?.title;
                            // return {
                            //     _id: metaId,
                            //     mataName: metadataList[index]?.title,
                            //     // mataName: 'item',
                            // };
                            // return item._id;
                        }) || [],
                    // curationCategoryList: curationCategoryList?.categoryList || [],
                };
            })
        );
    };

    useEffect(() => {
        constructList();
    }, []);


    const changePage = () => {

        const pageinput = document.getElementById('input_page_number');
        if(pageinput instanceof HTMLInputElement){
            page = pageinput.value;
        }


        const limitinput = document.getElementById('input_page_limit');
        if(limitinput instanceof HTMLInputElement){
            limit = limitinput.value;
        }

        const searchinput = document.getElementById('input_search');
        if(searchinput instanceof HTMLInputElement){
            search = searchinput.value;
        }

        setTimeout(()=> {
            constructList(true);
        }, 500);

    };

    const sort = (col: any) => {
        const index = columnInfo.findIndex((e) => e.name === col.name);
        columnInfo[index].isAscending = !columnInfo[index].isAscending;
        const sortedItems = [...stickerList].sort((a: any, b: any) => {
            if (typeof a[col.name] === 'number' || typeof a[col.name] === 'boolean') {
                return columnInfo[index].isAscending ? a[col.name] - b[col.name] : b[col.name] - a[col.name];
            }

            if (!a[col.name]) {
                a[col.name] = '';
            }
            if (!b[col.name]) {
                b[col.name] = '';
            }

            return columnInfo[index].isAscending ? a[col.name].localeCompare(b[col.name]) : b[col.name].localeCompare(a[col.name]);
        });
        stickerList = sortedItems;
        // setItems(sortedItems);
        constructList();
    };

    const handleInputSubmit = async (id: string, name: string, value: any) => {
        const index = stickerList.findIndex((sticker: any) => sticker._id === id);
        // if(name==='metaGroupIds') {
        //     value = value.split('\n');
        //     value = value.map((item: any)=> item.trim());
        // }

        stickerList[index][name] = value;
        console.log(id, name, value);
        constructList();
        await putSticker(id, { [name]: value });

        if (name === 'imageUrl') {
            const element = document.getElementsByClassName(`${name}-${id}`)[0];
            if (element instanceof HTMLImageElement) {
                console.log('String');
                element.src = value;
            }
        }
    };

    const handleAddSticker = async() => {
        console.log('stickerId', newStickerId);

        if(!newStickerId){
            return;
        }

        //대문자
        const newStickerIdUpperCase = newStickerId.toUpperCase();
        const index = stickerList.findIndex((sticker: any) => sticker._id === newStickerIdUpperCase);

        if(index > -1){
            return;
        }

        await postSticker({ _id: newStickerIdUpperCase,
            "eventPath": "",
            "group": "",
            "groupLevel": -1,
            "imageUrl": "",
            "message1": "",
            "message2": "",
            "name": "Change me",
            "categoryId": "",
            sort: 900, visible: false });

        setTimeout(()=> {
            constructList(true);
        }, 500);

        // setDefaultValue('');
    }

    // const handleNewsletterChange = async (id: string, name: string, value: any) => {
    //     console.log('selectedList: ', value);
    //     const index = stickerList.findIndex((newsletter: any) => newsletter._id === id);
    //     const valueToSave = value.map((category: any) => category._id);
    //     stickerList[index][name] = valueToSave;
    //     constructList();
    //     await putNewsletter(id, { [name]: valueToSave });
    // };

    const [targetId, setTargetId] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [targetMetaGroup, setTargetMetaGroup] = React.useState({_id: '', title: '', metaIds: []});
    const [open, setOpen] = React.useState(false);
    const [isSaving, setIsSaving] = React.useState(false);

    return (
        <div>
            <h1>스티커 관리</h1>

            <div className="uploader-wrapper" ref={divRef} style={{display: 'none'}}>
                <FileUploader fileUploaded={fileUploaded}
                              fileGot={fileGot}
                              accept='image/*'
                              multiple={false}
                    // locale={locale}
                              name={name}
                              url={url}
                              method={method}
                              beforeRequest= {beforeRequest}
                >
                </FileUploader>
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'}}>
                <Paper
                    component="form"
                    sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}
                >
                    <Typography>
                        신규 스티커 추가
                    </Typography>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        // value={defaultValue}
                        placeholder="스티커 ID (대문자)"
                        inputProps={{ "aria-label": "new sticker id" }}
                        onChange={event=>{                                 //adding the onChange event
                            setNewStickerId(event.target.value)
                        }}
                    />
                    <IconButton sx={{ p: "10px" }} aria-label="add">
                        <AddIcon onClick={handleAddSticker} />
                    </IconButton>
                </Paper>
            </div>

            <MainList
                onSortToggle={sort}
                onInputSubmit={handleInputSubmit}
                columnInfo={columnInfo}
                listData={items}
                multipleSelectList={metadataList}
                // onMultipleSelectCheckboxChange={handleNewsletterChange}
                buttons={[]}
                // imageUpload={imageUpload}
                // handleOpen={handleOpen}
                imageUpload={imageUpload}
                stickerCategoryList={stickerCategoryList}
            />
        </div>
    );
};
